import { RootState } from "@/store/store";
import { savingsOpportunitiesDataSelector } from "@/store/savings-opportunities/selectors/savingsOpportunitiesDataSelector";
import {
  AllPossibleTopOpportunitiesOptionsType,
  GroupedTopOpportunities,
} from "@/components/pages/common/opportunities/utils/types/types";
import { generateTopOpportunities } from "@/components/pages/common/opportunities/utils/helpers/generateTopOpportunities";

export const savingsOpportunitiesTopOpportunitiesGroupedDataSelector = (
  state: RootState,
  groupBy: AllPossibleTopOpportunitiesOptionsType,
  fittingItemsCount?: number,
): GroupedTopOpportunities | undefined => {
  const opportunities = savingsOpportunitiesDataSelector(state);

  if (!opportunities) {
    return;
  }

  return generateTopOpportunities(opportunities, groupBy, fittingItemsCount);
};
